import { redirect } from 'next/navigation';
import { getServerFeatureFlag } from '../../../statsig/sdk/server';
import { TFunction } from 'i18next';
import { initServerTranslation } from '@bts-web/utils-lokalise';
import { NavigationBackButton } from '../../../navigation';
import { FilledDismiss } from '../../../common/svgIcons';
import { NEXT_ROUTES } from '@bts-web/utils-next-infrastructure';
import { NavigationBar } from '../../../common';
import { AcceptStakeSummary } from '../AcceptStakeSummary/AcceptStakeSummary';
import { getStakingReward } from '../../../common/gqlActions';
import { getStakeTranslations } from '../../utils/getStakeTranslations';
import { GenericErrorMessage } from '../../../layouts/GenericErrorMessage/GenericErrorMessage';

export type AcceptStakeControllerProps = {
  assetId: string;
  amount: string;
};

export const AcceptStakeController = async ({
  assetId,
  amount,
}: AcceptStakeControllerProps) => {
  const { t } = await initServerTranslation();

  const feature_hasStakingEnabled = await getServerFeatureFlag(
    'feature_hasStakingEnabled',
  );

  const translations = getStakeTranslations(t as TFunction);

  if (!feature_hasStakingEnabled) {
    redirect(NEXT_ROUTES.PORTFOLIO);
  }

  const { data, errors } = await getStakingReward({
    assetAmount: amount,
    assetId,
  });

  if (errors || !data?.stakingReward) {
    return <GenericErrorMessage />;
  }

  return (
    <>
      <NavigationBar
        showBorderBottom
        title={translations.summary}
        NavigationLeftSlot={<NavigationBackButton />}
        NavigationRightSlot={
          <NavigationBackButton icon={<FilledDismiss size={24} />} />
        }
      />
      <AcceptStakeSummary
        stakingReward={data.stakingReward}
        translations={translations}
        assetId={assetId}
        amount={amount}
      />
    </>
  );
};
